// updatePusherDistinctId.js
'use strict';
import {
  setTrackHeader,
  getPusherFetchHeaders,
} from '../resource/fetchOptionHeader.js';
import { getMixpanelDistinctId } from '../resource/mixpanel.js';
import getMeData from '../selector/getMeData.js';
import * as MessageTypes from '../serviceWorker/AppMessageTypes.js';
import { sendMessageToSW } from '../serviceWorker/helpers.js';
import ServiceWorkerMessenger from '../resource/ServiceWorkerMessenger.js';

/**
 * Update mixpanel distinct id
 * @kind action
 * @param {string} [{distinctId}=''] - check the distinct id before updating when event from service worker
 * @param {boolean} [{isFromServiceWorker}=false] - the event is from server worker or not.
 * @return {Promise} Action promise.
 */
const updatePusherDistinctId =
  ({ distinctId = '', isFromServiceWorker = false } = {}) =>
  async (dispatch, getState) => {
    if (isFromServiceWorker) {
      const currentDistinctId = getMixpanelDistinctId();
      if (distinctId === currentDistinctId) return dispatch({ type: '' });
    }

    const state = getState();
    const utmObject = getMeData(state, 'utm');
    const token = getMeData(state, 'token');
    const meId = getMeData(state, 'id');
    const clientId = getMeData(state, 'clientId');
    const newDistinctId = getMixpanelDistinctId({ reload: true });

    setTrackHeader({
      utmObject,
      trackObject: { mixpanel_distinct_id: newDistinctId },
    });

    // update pusher headers
    const pusherHeaders = getPusherFetchHeaders({
      token,
      clientId,
    });
    sendMessageToSW({
      type: MessageTypes.SET_AUTH_HEADERS,
      payload: { headers: pusherHeaders },
    });
    const messenger = ServiceWorkerMessenger.getInstance();
    messenger.set({
      selectPath: ['scope', 'pusher', 'headers'],
      value: pusherHeaders,
      options: {
        isCritical: true,
        objectDepth: 2,
      },
    });

    if (meId) {
      // re-subscribe private-enc-user-v2@{USER_ID}
      sendMessageToSW({
        type: MessageTypes.SUBSCRIBE_PRIVATE_USER_V2_CHANNEL,
        payload: {
          userId: meId,
        },
      });
    }

    if (!isFromServiceWorker) {
      sendMessageToSW({
        type: MessageTypes.UPDATE_PUSHER_DISTINCT_ID,
        payload: {
          distinctId: newDistinctId,
        },
      });
    }

    return dispatch({ type: '' });
  };

export default updatePusherDistinctId;
